import axios from 'axios'

/**
 * @param {Object} http CSRF ヘッダー設定済みの HTTP クライアント
 * @returns {{get: Function}}
 */
export const usePickupClient = (http = axios) => {
  /**
   * @param {string} path Pickup API の相対パス
   * @param {Object} [config] HTTP リクエストの設定
   * @returns {Promise<*>} レスポンスの data フィールド
   */
  const get = async (path, config) => {
    try {
      const response = await http.get(`/api/v1/pickup/${path}`, config)
      return response.data.data
    } catch (cause) {
      // HTTP 固有のエラー構造を UI に渡さず、既存の通知文言を保持する。
      throw new Error(cause.response?.data?.message || '', { cause })
    }
  }

  return { get }
}
